import "./summary-step.scss";
import SubmittalsBigIcon from "components/svg-icons/submittals-big-icon";
import MaterialsBigIcon from "components/svg-icons/material-big-icon";
import ActivityBigIcon from "components/svg-icons/activitiy-big-icon";
import LinkBigIcon from "components/svg-icons/link-big-icon";
import AiPoweredUI from "components/welcome-startup-setup/ai-powered";
import LinkIcon from "components/svg-icons/link-icon";
import { TSummary } from "components/welcome-startup-setup/model";

export const imgDiv = (subTitle: string) => {
  switch (subTitle) {
    case "Submittals":
      return <SubmittalsBigIcon />;
    case "Materials":
      return <MaterialsBigIcon />;
    case "Schedule Activities":
      return <ActivityBigIcon />;
    case "Links":
      return <LinkBigIcon />;
    default:
      break;
  }
  return "";
};

export default function SummaryStep({
  summary,
  projectName
}: {
  summary: TSummary | undefined;
  projectName: string | undefined;
}) {
  const cardDiv = (
    title: any,
    subTitle: any,
    highRiskCount = 1,
    criticalTasksCount = 0
  ) => {
    return (
      <div className="grid grid-rows-3 w-[206px] h-[280px] px-4 py-6 rounded-md border border-solid border-ciq-gray-100">
        <div className="flex items-center justify-center">
          {imgDiv(subTitle)}
        </div>
        <div className="title text-center truncate -my-2" title={title}>
          {title}
          <div className="subTitle w-full text-center px-1">{subTitle}</div>
          {highRiskCount > 0 && (
            <div className="flex justify-center space-x-1 py-1">
              <div className="riskCount">{highRiskCount}</div>
              <div className="riskText">at High Risk</div>
            </div>
          )}
          {criticalTasksCount > 0 && (
            <div className="flex justify-center space-x-1 py-1">
              <div className="riskCount">{criticalTasksCount}</div>
              <div className="riskText">on the Critical Path</div>
            </div>
          )}
        </div>
        {subTitle === "Submittals" && (
          <div className="flex flex-col items-center justify-end space-y-2">
            <div className="flex text-xs font-normal text-black text-opacity-85 text-center ">
              synchronized from Autodesk Forma
            </div>
          </div>
        )}
        {subTitle === "Materials" && (
          <div className="flex flex-col items-center justify-end space-y-2">
            <AiPoweredUI />
            <div className="flex text-xs font-normal text-black text-opacity-85 text-center ">
              extracted from{" "}
              <span className="text-ciq-blue-700 text-xs font- mx-1">
                {summary?.drawings_count ?? 0}
              </span>{" "}
              drawings
            </div>
          </div>
        )}
        {subTitle === "Schedule Activities" && (
          <div className="flex flex-col items-center justify-end space-y-2">
            <div className="text-xs font-normal text-opacity-80 text-center ">
              related to Procurement, out of
              <span className="px-1 text-ciq-blue-700 font-bold">
                {summary?.schedule_activities_count}
              </span>
              total
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="flex justify-center items-center pt-6">
      <div className="flex flex-col summary-step">
        <div className="flex w-full justify-center text-xs font-bold text-black text-opacity-85 mb-2">
          {projectName}
        </div>
        <div className="flex w-full justify-center font-bold text-ciq-gray-975 text-xl mb-4">
          You’re all set!
        </div>
        <div className="flex space-x-4 justify-center items-center">
          {cardDiv(
            summary?.submittals_count ?? 0,
            "Submittals",
            summary?.submittals_needing_attention ?? 0
          )}
          {cardDiv(
            summary?.materials_count ?? 0,
            "Materials",
            summary?.materials_needing_attention
          )}
          {cardDiv(
            summary?.unique_activities_linked ?? 0,
            "Schedule Activities",
            0,
            summary?.unique_critical_activities_linked ?? 0
          )}
        </div>
        <div className="w-full rounded-md border border-solid border-ciq-gray-100 mt-4 p-2">
          <div className="w-full flex flex-col justify-center items-center">
            <div className="flex space-x-1 items-center justify-center">
              <LinkIcon />
              <div className="text-2xl font-bold text-ciq-blue-700">
                {summary?.links_created_by_system ?? 0}
              </div>
              <div className="font-bold text-xs">Procurement Dependencies</div>
            </div>
            <div className="flex flex-col justify-center opacity-60 px-10 text-xs">
              <div>
                These are connections between entities to calculate planning
                dates.
              </div>
              <div>
                Made using our Smart Linking model, based on industry knowledge.
              </div>
            </div>
          </div>
          <div className="w-full flex justify-center items-center py-2">
            <AiPoweredUI />
          </div>
        </div>
      </div>
    </div>
  );
}
